"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isDev() {
    var devHosts = ["localhost", "imsecurityproducts", "qaintermedia"];
    return devHosts.some(function (host) { return window.location.origin.indexOf(host) !== -1; });
}
exports.isDev = isDev;
